export function SkinsResultCard() {
  return (
    <div
      className="bg-white rounded-xl border border-gray-100 p-6 text-center"
      data-testid="card-skins-stub"
    >
      <p className="text-sm font-semibold text-gray-500">Skins results coming soon</p>
    </div>
  );
}
